import React from "react";
export default function SchedulePage() {
  return (
    <div style={{ padding: "2rem" }}>
      {" "}
      <h2>Schedule</h2> <p>Upcoming activities and events (dummy).</p>{" "}
    </div>
  );
}
